import { render, staticRenderFns } from "./ListCompanies.vue?vue&type=template&id=f6c0a08a&"
import script from "./ListCompanies.vue?vue&type=script&lang=js&"
export * from "./ListCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports